import { call, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { createUser, getAuthenticatedUser } from '../../../api/user';
import { toastError, toastSuccess } from '../../../helpers/toast-helper';
import {
	getAuthUserDetails,
	getAuthUserDetailsFail,
	getAuthUserDetailsSuccess,
	registerAuthUserFail,
	registerAuthUserSuccess,
} from './actions';
import { GET_USER_DETAILS, REGISTER_USER } from './actionTypes';

function* getAuthUserDetailsWorker() {
	try {
		const response = yield call(getAuthenticatedUser);

		if (response?.success) {
			yield put(getAuthUserDetailsSuccess(response));
		} else {
			yield put(getAuthUserDetailsFail(response?.error));
		}
	} catch (error) {
		yield put(getAuthUserDetailsFail(error));
	}
}

function* registerAuthUserWorker({ payload }) {
	try {
		const response = yield call(createUser, payload);

		if (response?.success) {
			yield put(registerAuthUserSuccess(response));
			toastSuccess('User was successfully registered');

			yield put(getAuthUserDetails(payload.email));
		} else {
			yield put(registerAuthUserFail(response?.error));
		}
	} catch (error) {
		yield put(registerAuthUserFail(error));
		toastError('Cannot register user');
	}
}

function* authSaga() {
	yield takeEvery(GET_USER_DETAILS, getAuthUserDetailsWorker);
	yield takeEvery(REGISTER_USER, registerAuthUserWorker);
}

export default authSaga;
